import React from 'react';
import { useFormikContext } from 'formik';
import { makeStyles } from '@material-ui/core';
import green from '@material-ui/core/colors/green'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Chip from '@material-ui/core/Chip';
import Hidden from '@material-ui/core/Hidden';
import { AppService } from '../common/AppService'

const useStyles = makeStyles(theme => ({
  chip: {
    float: 'right',

    '& .MuiChip-icon': {
      color: green[400],
    },

    '&.Mui-disabled .MuiChip-icon': {
      color: theme.palette.grey[400],
    },
  },
}));

const Autosave = () => {
  const classes = useStyles();
  const { dirty, values } = useFormikContext();
  const [timeoutId, setTimeoutId] = React.useState();
  const [formState, setFormState] = React.useState('saved');
  const appService = new AppService();

  React.useEffect(() => {
          if (dirty) {
              setFormState('unsaved');
              if (timeoutId) {
                  window.clearTimeout(timeoutId);
              }
              setTimeoutId(window.setTimeout(() => {

                      const storedUser: any = localStorage.getItem('Alutiiq-PreQualificationPortal/user');
                      if (storedUser) {
                          const user = JSON.parse(storedUser);
                          if (user && user.email) {
                              appService.saveDueDiligence(user.email, values);
                          }
                      }
                      localStorage.setItem('Alutiiq-PreQualificationPortal/formData', JSON.stringify(values));
                      setFormState('saving');
                      window.setTimeout(() => {
                              setFormState('saved');
                          },
                          0)
                  },
                  1000));
          }
      },
      [values]);

  return (
    <Hidden xsDown>
      <Chip
        className={classes.chip}
        disabled={formState !== 'saved'}
        icon={<CheckCircleIcon />}
        label="Autosave"
        variant="outlined"
      />
    </Hidden>
  );
}

export default Autosave;
